// extracted by mini-css-extract-plugin
module.exports = {"zipInfo":"ItemImport_zipInfo__ACUgw","infoIcon":"ItemImport_infoIcon__3DgEp","dropzone":"ItemImport_dropzone__3rF9w","error":"ItemImport_error__36g-J"};